import {isEmpty, isNil} from 'ramda';

import {DiscountApplicationMethodSettings} from '@dms/api/finance';

import {Nullish} from 'shared/web';

import {getEmptyDiscountValidity} from './getEmptyDiscountValidity';

const DEFAULT_APPLICATION_METHOD = 'DISCOUNT_APPLICATION_ON_TOTAL_SELLING_PRICE';

export const getDiscountApplicationMethodDefaultValues = (
  settings: DiscountApplicationMethodSettings | Nullish
): DiscountApplicationMethodSettings => {
  const applicationMethod = settings?.applicationMethod ?? DEFAULT_APPLICATION_METHOD;
  const validities = settings?.validities;

  if (isNil(validities) || isEmpty(validities)) {
    return {applicationMethod, validities: [getEmptyDiscountValidity()]};
  }

  return {applicationMethod, validities};
};
